// Author: Sunil Jain
// Timestamp: 2025-04-29 08:25:00 AM EDT
// File: src/components/ErrorBoundary.js

import React from 'react';
import { Alert, AlertTitle, Box, Typography, Paper } from '@mui/material';
import logger from '../utils/logger'; // Ensure logger is correctly imported

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ m: 4 }}>
            <Paper elevation={3} sx={{p: 3}}>
                 <Alert severity="error">
                     <AlertTitle>Something went wrong</AlertTitle>
                     <Typography variant="body2">A rendering error occurred. Please try refreshing.</Typography>
                     {process.env.NODE_ENV === 'development' && (
                         <Box sx={{ mt: 2, maxHeight: 200, overflow: 'auto', bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
                             <Typography variant="caption" component="pre" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                 {this.state.error && this.state.error.toString()}
                                 <br />
                                 {this.state.errorInfo && this.state.errorInfo.componentStack}
                             </Typography>
                         </Box>
                     )}
                 </Alert>
            </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;